import { useEnvStore } from 'store'
import { RequestService } from '../RequestService'

export type QueryAssetLogParams = {
  assetsTypeList: string
  itemIdList: string
  statusList: string
  createTime: number
  endTime: number
  pageSize: number
}

class SotcRequest extends RequestService {
  constructor() {
    super()
  }

  protected setBaseUrl(): string {
    const envStore = useEnvStore()
    return envStore.config?.sotc || ''
  }

  getAccountBill(data: ApiRequest.PageBody & QueryAssetLogParams) {
    return this.post<HasPageInfoResponse<ApiResponse.AccountBillRecord>>('/SecretOtc/App/getAssetsLog', data)
  }
}

export const SotcServices = new SotcRequest()
